import _ from "lodash";

export default {
    data() {
        return {
            groupingField: null,
            groupMap: null,
            groupWay: null,
        }
    },
    methods: {
        whenGrouping(field, map) {
            if (map == null) {
                this.groupingField = null;
                this.groupMap = null;
                this.groupWay = null;
            } else {
                this.groupingField = field;
                this.groupMap = map.groupMap;
                this.groupWay = map.groupWay;
            }
        },
        groupRows(rows) {
            if (this.groupMap == null) {
                return rows;
            }
            let keys = Object.keys(this.groupMap);
            let order = 'desc';
            if (this.sortBy === this.groupingField && !this.sortDesc) {
                order = 'asc';
            }
            keys = _.orderBy(keys, null, order);
            let tempList = [];
            for (let str of keys) {
                let temp = {
                    _rowVariant: 'info',
                    _isGroupTag: true
                }
                temp[this.groupingField] = str;
                tempList.push(temp);

                let itemSet = this.groupMap[str];
                for (let row of rows) {
                    let item = row[this.groupingField];
                    if (itemSet.has(item)) {
                        tempList.push(row);
                    }
                }
            }
            return tempList;
        },

        isGroupRow(data) {
            return data.item._isGroupTag;
        },
        clearIfGroup(key) {
            if (this.groupingField === key) {
                this.groupingField = null;
                this.groupMap = null;
            }
        },
    }
}
